import {navigateTo} from '@typed-router';
import {storeToRefs} from 'pinia';
import {defineNuxtRouteMiddleware} from '#app';
import {useAuth, useLocalePrefix} from '#imports';
import {useLazyFeatureFlag} from '@malt/feature-flags';
import {useAdvancedSearchStore} from '~/features/advanced-search/stores/advancedSearch.store';

export default defineNuxtRouteMiddleware(async (to) => {
    const auth = useAuth();
    const {withLocalePrefix, withoutLocalePrefix} = useLocalePrefix();

    // Unlogged users on malt.com may still carry a locale prefix; strip before matching.
    const briefId = withoutLocalePrefix(to.path).match(/^\/s\/advanced\/([a-fA-F0-9]{24})/)?.[1];

    if (!briefId) {
        return;
    }

    const advancedSearchStore = useAdvancedSearchStore();
    const {advancedSearch} = storeToRefs(advancedSearchStore);

    const projectProposalSummariesUrl = '/project-proposal-summaries';

    const isAdvancedSearchNotLoaded = !advancedSearch.value;
    const isAdvancedSearchShouldBeReloaded = advancedSearch.value?.briefId !== briefId;

    if (isAdvancedSearchNotLoaded || isAdvancedSearchShouldBeReloaded) {
        try {
            // We fetch this FF to ensure exposure event related to the AB test is sent before loading the selection results.
            // https://maltcommunity.slack.com/archives/C08FW5L9RR9/p1772705328329109
            useLazyFeatureFlag('delicate-shad-matching-system');
            await advancedSearchStore.loadAdvancedSearch(briefId);
        } catch (_) {
            if (auth.loggedIn) {
                return navigateTo(projectProposalSummariesUrl, {external: true});
            }
            // Public exit: unlogged users must keep the locale prefix toward signin.
            return navigateTo(withLocalePrefix(`/signin?redirect=${encodeURIComponent(to.path)}`), {external: true});
        }
    }

    if (advancedSearch.value && advancedSearch.value.submissionState !== 'UNSUBMITTED') {
        return navigateTo(projectProposalSummariesUrl, {external: true});
    }
});
